import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

import './custom'
import './link-cursor'
import './motion'
import './page-transitions'
import './page-init'
